/**
 * Area names are data: they come from the API (`area.name`) and are only tidied for display. The only place that decides
 * how an area is written (full name, short code, tooltip).
 */
const SMALL_WORDS = new Set(['de', 'del', 'la', 'y', 'el', 'los', 'las'])

function titleCase(text: string): string {
  if (text.length <= 3 && text === text.toUpperCase()) return text // codes such as PKO stay as they are
  return text
    .toLowerCase()
    .split(/\s+/)
    .map((w, i) => (i > 0 && SMALL_WORDS.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ')
}

export function areaLabel(code: string | undefined, name?: string): string {
  if (name) return titleCase(name)
  return code ?? '—'
}

export function areaCode(area: { code: string; name?: string }): string {
  return area.code
}

export function areaTitle(area: { code: string; name: string }): string {
  return `${area.name} (${area.code})`
}
